import firebase from '../firebase/firebase';
import {
    SET_INFO_AUTH,
    SET_IS_ADMIN,
} from './types';

const base_url = process.env.NODE_ENV === 'development' ? 'http://localhost:3000' : 'https://seekcity.web.app'

export const signInWithGoogle = (history) => async (dispatch) => {
    const provider = new firebase.auth.GoogleAuthProvider()

    const { user: { uid } } = await firebase.auth().signInWithPopup(provider);
    const doc = await firebase.firestore().collection('users_ui').doc(uid).get();
    console.log('here')
    if (doc.exists) {
        const { isAdmin } = doc.data();

        dispatch({
            type: SET_IS_ADMIN,
            payload: isAdmin,
        })
    }

    history.push(`/dashboard-user=${uid}`);
}

export const signOut = () => async (dispatch) => {
    await firebase.auth().signOut();
}

export const signIn = (email) => async dispatch => {
    try {
        localStorage.setItem('emailForSignIn', email);

        await firebase
            .auth()
            .sendSignInLinkToEmail(email, {
                url: `${base_url}/dashboard-${email}`,
                handleCodeInApp: true,
            })

        dispatch({
            type: SET_INFO_AUTH,
            payload: {
                info: "Please click on the login link we've sent to your mail",
                status: 200,
            }
        })
    } catch (e) {
        dispatch({
            type: SET_INFO_AUTH,
            payload: {
                info: "An error occured, please try again",
                status: 500,
            }
        })
    }
};

